<template>
  <custom-crud-list v-bind="listConfiguration">
    <template #cell-VendorId="{ item }">
      <span>{{ item.Vendor ? item.Vendor?.name : "-" }}</span>
    </template>
    <template #cell-introImage="{ item }">
      <block class="flex flex-center flex-middle" style="width: 100px">
        <img
          :src="item.introImage"
          style="max-height: 50px; width: auto; max-width: 100px"
          alt="" />
      </block>
    </template>
    <template #cell-price="{ item }">
      <span class="no-word-break">{{
        translateNumber(item.price, "currency", { from: item.currency })
      }}</span>
    </template>
    <template #cell-bidStarts="{ item }">
      <span class="no-word-break">{{
        item.AuctionProductType
          ? translateNumber(item.AuctionProductType.startingPrice, "currency", {
              from: item.currency,
            })
          : "-"
      }}</span>
    </template>
    <template #cell-quantity="{ item }">
      <span>{{
        item?.JustoppDealProductType?.maximumQuantity
          ? translateNumber(item?.JustoppDealProductType?.maximumQuantity)
          : "-"
      }}</span>
    </template>
    <template #cell-category="{ item }">
      <span>{{ item.Category ? item.Category.name : "-" }}</span>
    </template>
  </custom-crud-list>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import CustomCrudList from "@/client/components/crud/customV1/List.vue";
import vendorProductCreateFromConfigFactory from "@/client/applications/justopp/assets/static/forms/vendorProductFormFactory.js";

export default {
  components: { CustomCrudList },
  props: {
    // vendor ID
    vendorId: {
      type: String,
      default: 0,
    },
    overrideListConfiguration: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "justopp.vendorDashboard.browserTitle",
  data() {
    let createForm = vendorProductCreateFromConfigFactory({
      vendorId: this.vendorId,
      userProfile: this.$store.getters["user/profile"],
    });
    let categoryField = createForm.fields.CategoryId;
    categoryField.placeholder = categoryField.label;
    delete categoryField.label;
    return {
      listConfiguration: {
        subject: "product",
        listSrc: "ecommerce/product",
        showIdField: true, // bool deafult true
        sortable: false, //bool, default false
        publishable: true, //bool, default false
        enableMassActions: true,
        createRoute: {
          name: "company-vendorId-dashboard-products-create",
          params: { vendorId: this.vendorId },
        },
        editRoute: (item) => {
          this.$router.push({
            name: "company-vendorId-dashboard-products-edit-productId",
            params: { vendorId: this.vendorId, productId: item.id },
          });
        },
        additionalListData: {
          simplified: false,
          translate: true,
        },
        constantFilters: {
          VendorId: this.vendorId,
        },
        // add filters: category
        // add sortings: price, endDate,
        noItemsFoundText: "justopp.vendorDeals.noDeals",
        fields: {
          // these are the table columns
          name: {
            itemKey: "name",
            label: "justopp.vendorDeals.fields.name",
            filterable: true, // boolean, or object
            orderable: true,
          },
          code: {
            itemKey: "code",
            label: "justopp.vendorDeals.fields.code",
            orderable: false,
          },
          price: {
            itemKey: "price",
            label: "justopp.vendorDeals.fields.price",
            filterable: false, // boolean, or object
            orderable: true,
          },
          bidStarts: {
            itemKey: "bidStarts",
            label: "justopp.vendorDeals.fields.bidStarts",
            orderable: false,
          },
          quantity: {
            itemKey: "quantity",
            label: "justopp.vendorDeals.fields.quantity",
            filterable: false, // boolean, or object
            orderable: false,
          },
          category: {
            itemKey: "category",
            label: "justopp.vendorDeals.fields.category",
            filterable: categoryField, // boolean, or object
            orderable: false,
          },
        },
        actions: {
          show: false,
          edit: true,
          delete: false,
        },
        ...this.overrideListConfiguration,
      },
      asyncData: {},
    };
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.no-word-break {
  word-break: normal;
}
</style>
